import { SteppedEase, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const scrapbookB: gsapTimelineFunc = (targets) => {
  return gsap
    .timeline({ defaults: { ease: SteppedEase.config(2) } })
    .fromTo(
      targets,
      { duration: 0, opacity: 0, translateX: '-300%', rotateZ: 35 },
      { duration: 0.5, opacity: 1, translateX: '50%', rotateZ: -65 }
    )
    .to(targets, { duration: 0.5, translateX: '0%', rotateZ: 0 });
};
